import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Permission } from 'src/app/models/permission.model';
import { ViewType } from 'src/app/enums/view-type.enum';
import { UserSaved } from 'src/app/models/user.model';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationService {
	private url = 'https://app.dev.servicios.gt/';

	constructor(private http: HttpClient) { }

	getCurrentUser() {
		return localStorage.getItem('user');
	}

	getUser(): UserSaved {
		return JSON.parse(localStorage.getItem('user')) as UserSaved;
	}

	isPartner(): boolean  {
		return this.getUser().contadorGT;
	}

	setUser(user: UserSaved) {
		return localStorage.setItem('user', JSON.stringify(user));
	}

	setCurrentCompany(company: any) {
		return localStorage.setItem('current-company', company);
	}

	setViewType(viewType = ViewType.NORMAL) {
		return localStorage.setItem('view2', viewType + "");
	}

	setCurrentCompanyId(companyId: any) {
		return localStorage.setItem('inin-company', companyId);
	}

	getCurrentCompany() {
		return localStorage.getItem('current-company');
	}

	getCurrentCompanyId() {
		return localStorage.getItem('inin-company');
	}

	getPermissions(): Permission[] {
		return JSON.parse(localStorage.getItem('permissions'));
	}

	getView(){
		return localStorage.getItem("view2");
	}

	setPermissions(permissions: Permission[]) {
		return localStorage.setItem('permissions', JSON.stringify(permissions));
	}

	setUserPosition(userPosition) {
		return localStorage.setItem('userPosition', JSON.stringify(userPosition));
	}

	getUserPosition(): any {
		return JSON.parse(localStorage.getItem('userPosition'));
	}

	clearCompany() {
		localStorage.removeItem('current-company');
		localStorage.removeItem('inin-company');
		localStorage.removeItem('userPosition');
		localStorage.removeItem('permissions');
	}

	logout() {
		localStorage.removeItem('user');
		localStorage.removeItem('permissions');
		localStorage.removeItem('current-company');
		localStorage.removeItem('inin-company');
		localStorage.removeItem('jwt');
		localStorage.removeItem('profits');
		localStorage.removeItem('userPosition');
	}
}